// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".home-page .search{align-items:center;display:flex}.home-page .search>INPUT{background-color:transparent;height:30px;padding:8px}.home-page h2{font-size:16px}", ""]);
// Exports
module.exports = exports;
